import { extendedPetApi } from './injectedAirflowApi';

export const enhancedAirflowApi = extendedPetApi.enhanceEndpoints({
    addTagTypes: ['GetDagRuns', 'GetDags'],
    endpoints: {
        getDags: {
            providesTags: ['GetDags'],
        },
        getDagRunsBatchCustom: {
            providesTags: ['GetDagRuns'],
        },
        getDagRuns: {
            providesTags: ['GetDagRuns'],
        },
        postDagRun: {
            invalidatesTags: ['GetDagRuns'],
        },
    },
});
export interface DagDetailParams {
    description?: any;
    schema?: any;
    value?: any;
    __class?: any;
}

export const {
    useGetConnectionsQuery,
    usePostConnectionMutation,
    useGetConnectionQuery,
    usePatchConnectionMutation,
    useDeleteConnectionMutation,
    useTestConnectionMutation,
    useGetDagsQuery,
    useLazyGetDagsQuery,
    usePatchDagsMutation,
    useGetDagQuery,
    usePatchDagMutation,
    useDeleteDagMutation,
    usePostClearTaskInstancesMutation,
    useSetTaskInstanceNoteMutation,
    useSetMappedTaskInstanceNoteMutation,
    usePostSetTaskInstancesStateMutation,
    useGetDagRunsQuery,
    usePostDagRunMutation,
    useGetDagRunQuery,
    useDeleteDagRunMutation,
    useUpdateDagRunStateMutation,
    useClearDagRunMutation,
    useGetUpstreamDatasetEventsQuery,
    useSetDagRunNoteMutation,
    useGetEventLogsQuery,
    useGetEventLogQuery,
    useGetImportErrorsQuery,
    useGetImportErrorQuery,
    useGetPoolsQuery,
    usePostPoolMutation,
    useGetPoolQuery,
    usePatchPoolMutation,
    useDeletePoolMutation,
    useGetProvidersQuery,
    useGetTaskInstancesQuery,
    useGetTaskInstanceQuery,
    usePatchTaskInstanceMutation,
    useGetMappedTaskInstanceQuery,
    usePatchMappedTaskInstanceMutation,
    useGetMappedTaskInstancesQuery,
    useGetTaskInstancesBatchMutation,
    useGetVariablesQuery,
    usePostVariablesMutation,
    useGetVariableQuery,
    usePatchVariableMutation,
    useDeleteVariableMutation,
    useGetXcomEntriesQuery,
    useGetXcomEntryQuery,
    useGetExtraLinksQuery,
    useGetLogQuery,
    useGetDagDetailsQuery,
    useLazyGetDagDetailsQuery,
    useGetTasksQuery,
    useGetTaskQuery,
    useGetDagSourceQuery,
    useGetDagWarningsQuery,
    useGetDatasetsQuery,
    useGetDatasetQuery,
    useGetDatasetEventsQuery,
    useGetConfigQuery,
    useGetHealthQuery,
    useGetVersionQuery,
    useGetPluginsQuery,
    useGetRolesQuery,
    usePostRoleMutation,
    useGetRoleQuery,
    usePatchRoleMutation,
    useDeleteRoleMutation,
    useGetPermissionsQuery,
    useGetUsersQuery,
    usePostUserMutation,
    useGetUserQuery,
    usePatchUserMutation,
    useDeleteUserMutation,
    useGetDagRunsBatchCustomQuery,
} = enhancedAirflowApi;
